<Title name="{"Hotkeys"}" settingsPage={true} />

<LazyPage {pageComponent} {params} />

<script>
  import Title from '../_components/Title.html'
  import LazyPage from '../_components/LazyPage.html'
  import pageComponent from '../_pages/settings/hotkeys.html'

  export default {
    components: {
      Title,
      LazyPage
    },
    data: () => ({
      pageComponent
    })
  }
</script>
